import React from 'react';
import { Box, Divider } from '@material-ui/core';

/**
 * @fileoverview Pie de tarjeta para widgets del Panel Dinámico.
 * @module DpCardFooter
 */

/**
 * Componente DpCardFooter.
 *
 * Contenedor para elementos situados en la parte inferior de una tarjeta.
 * Incluye un divisor visual y espaciado consistente.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {React.ReactNode} props.children - Elementos a mostrar en el pie de la tarjeta.
 *
 * @returns {React.ReactElement} Pie de tarjeta con divisor.
 * 
 * @author David Maldonado
 * (c) Servicios de Monitoreo S.A. - Santiago, Chile
 */
export function DpCardFooter({ children }) {
  return (
    <Box>
      <Divider />
      <Box padding={1}>{children}</Box>
    </Box>
  );
}
